/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class TrueGritGameAssets {

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_FONT_WIN_NUMBERS = "winNumbers";
    static BITMAP_FONT_MULTIPLIER_NUMBERS_ENABLED = "multiplierNumbers";
    static BITMAP_FONT_MULTIPLIER_NUMBERS_DISABLED = "multiplierNumbersDisabled";
    static BITMAP_FONT_WAYS_NUMBERS = "waysNumbers";
    static BITMAP_FONT_NUMBERS_WAYS_WON = "numbersWaysWon";
    static BITMAP_FONT_FS_NUMBERS = "fsNumbers";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static MAIN_GAME_FOREGROUND:string = "foreground";
    public static FS_BACKGROUND:string = "freespinBackground";
    public static FS_FOREGROUND:string = "fs_foreground";
    public static SUPER_FS_BACKGROUND:string = "superFreespinBackground";
    public static SUPER_FS_FOREGROUND:string = "sfs_foreground";

    public static FS_OUTRO_BACKGROUND:string = "fs/fsIntroBG";
    public static FS_INTRO_BACKGROUND:string = "fs/fsIntroBG";

    public static TORTURE_SPINS_LOGO:string = "fs/tortureSpins";
    public static TORTURE_SPINS_INTRO_BANNER:string = "fs/tortureSpinsIntroBanner";
    public static TORTURE_SPINS_OUTRO_BANNER:string = "fs/tortureSpinsOutroBanner";

    public static DEAD_SPINS_LOGO:string = "superFS/deadSpins";
    public static DEAD_SPINS_INTRO_BANNER:string = "superFS/deadSpinsIntroBanner";
    public static DEAD_SPINS_OUTRO_BANNER:string = "superFS/deadSpinsOutroBanner";

    public static REEL_BACKGROUND:string = "reelBg";
    public static REEL_BACKGROUND_FS:string = "fs_reelBg";
    public static REEL_BACKGROUND_SUPER_FS:string = "super_fs_reelBg";

    public static W2_FLAME:string = "W2_FLAME";
    public static W2_SPARKS:string = "W2_SPARKS";

    static TRANSFORM_MID_SHINE:string = "TRANSFORM_SHINE";
    static TRANSFORM_MID_BACKGROUND:string = "T/T1_bg";
    static TRANSFORM_MID_FRAME:string = "T/T1_frame";

    static TRANSFORM_LOW_SHINE:string = "TRANSFORM_LOW_SHINE"
    static TRANSFORM_LOW_REVEAL:string = "TRANSFORM_LOW_REVEAL"
    static TRANSFORM_LOW_BACKGROUND:string = "T2/T2bg";
    static TRANSFORM_LOW_FRAME:string = "T/T1_frame";


    static BW_FRAME:string = "bigwinFrameSource";
    static BW_MASK:string = "bigwinMaskSource"; //Loaded  in img loader
    static BW_LEVEL_PREFIX:string = "bigWinLevel";


    public static BW_PARTICLES_LEVEL_1:string[] = [
        "bigWin/particles/level1-1",
        "bigWin/particles/level1-2",
        "bigWin/particles/level1-3"
    ];

    static BW_PARTICLES_LEVEL_2:string[] = [
        "bigWin/particles/level2-1",
        "bigWin/particles/level2-2"
    ];

    static BW_PARTICLES_LEVEL_3:string[] = [
        "bigWin/particles/level3-1",
    ];

    static BW_PARTICLES_LEVEL_4:string[] = [
        "bigWin/particles/level4-1",
        "bigWin/particles/level4-2"
    ];

    static BW_PARTICLES_LEVEL_5:string[] = [
        "bigWin/particles/level5-1",
        "bigWin/particles/level5-2",
        "bigWin/particles/level5-3"
    ];

    static SNOW_PARTICLE_1:string = "snow1";
    static SNOW_PARTICLE_2:string = "snow2";
    static SNOW_PARTICLE_3:string = "snow3";

    //Spine
    static TRANSFORM_TO_WILD_SPINE:string = "spine/w_transform.json";
    static LOW_SPLIT_SPINE:string = "spine/l_split.json";
    static MID_SPLIT_SPINE:string = "spine/m_split.json";
    static WILD_SPLIT_SPINE:string = "spine/w_split.json";
    static XWAY_SPINE:string = "spine/m_triggers.json";
    static GRETA_SPLIT_SPINE:string = "spine/m0_split.json";
    static WIN_CAP_SPINE:string = "spine/wincap.json";


    static WAYS_WON_TEXT:string = "text/waysWon";
    static WAY_WON_TEXT:string = "text/wayWon";


    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [],

        main : [
            {
                name : "fonts",
                assets : [
                    new BitmapFontAsset(TrueGritGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(TrueGritGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(TrueGritGameAssets.BITMAP_FONT_WIN_NUMBERS, "fonts/bitmapfonts/WinNumbers.fnt"),
                    new BitmapFontAsset(TrueGritGameAssets.BITMAP_FONT_MULTIPLIER_NUMBERS_ENABLED, "fonts/bitmapfonts/MultiplierNumbers.fnt"),
                    new BitmapFontAsset(TrueGritGameAssets.BITMAP_FONT_MULTIPLIER_NUMBERS_DISABLED, "fonts/bitmapfonts/MultiplierNumbersDisabled.fnt"),
                    new BitmapFontAsset(TrueGritGameAssets.BITMAP_FONT_WAYS_NUMBERS, "fonts/bitmapfonts/WaysNumbers.fnt"),
                    new BitmapFontAsset(TrueGritGameAssets.BITMAP_FONT_NUMBERS_WAYS_WON, "fonts/bitmapfonts/NumbersWaysWon.fnt"),
                    new BitmapFontAsset(TrueGritGameAssets.BITMAP_FONT_FS_NUMBERS, "fonts/bitmapfonts/FsNumbers.fnt")
                ]
            },
            {
                name : "backgrounds",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json")
                ]
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset(TrueGritGameAssets.TRANSFORM_TO_WILD_SPINE, TrueGritGameAssets.TRANSFORM_TO_WILD_SPINE),
                    new SpineAsset(TrueGritGameAssets.LOW_SPLIT_SPINE, TrueGritGameAssets.LOW_SPLIT_SPINE),
                    new SpineAsset(TrueGritGameAssets.MID_SPLIT_SPINE, TrueGritGameAssets.MID_SPLIT_SPINE),
                    new SpineAsset(TrueGritGameAssets.WILD_SPLIT_SPINE, TrueGritGameAssets.WILD_SPLIT_SPINE),
                    new SpineAsset(TrueGritGameAssets.XWAY_SPINE, TrueGritGameAssets.XWAY_SPINE),
                    new SpineAsset(TrueGritGameAssets.GRETA_SPLIT_SPINE, TrueGritGameAssets.GRETA_SPLIT_SPINE),
                    new SpineAsset(TrueGritGameAssets.WIN_CAP_SPINE, TrueGritGameAssets.WIN_CAP_SPINE),
                ]
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json")
                ]
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json")
                ]
            },
            {
                name : "symbolsNormalQuality",
                assets : [
                    new TextureAsset("symbolsNormalQuality0", "sheets/symbolsNormalQuality/symbolsNormalQuality0.json")
                ],
                animations : {}
            },
            {
                name : "symbolsHighQuality",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsHighQuality0", "sheets/symbolsHighQuality/symbolsHighQuality0.json"),
                    new TextureAsset("symbolsHighQuality1", "sheets/symbolsHighQuality/symbolsHighQuality1.json"),
                    new TextureAsset("symbolsHighQuality2", "sheets/symbolsHighQuality/symbolsHighQuality2.json"),
                ],
                animations : {
                    [TrueGritGameAssets.W2_FLAME] : "W2/W2flame/W2flame_00",
                    [TrueGritGameAssets.W2_SPARKS] : "W2/W2sparks/W2sparks_00",
                    [TrueGritGameAssets.TRANSFORM_MID_SHINE] : "T/transformShine/T1shine_00",
                    [TrueGritGameAssets.TRANSFORM_LOW_SHINE] : "T2/T2Transform/T2Transform_00",
                    [TrueGritGameAssets.TRANSFORM_LOW_REVEAL] : "T2/T2Reveal/T2Reveal_00"
                }
            },
            {
                name : "symbolParts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolParts0", "sheets/symbolParts/symbolParts0.json"),
                    new TextureAsset("symbolParts1", "sheets/symbolParts/symbolParts1.json")
                ],
                animations : {}
            },
            {
                name : "foregrounds",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("foregrounds0", "sheets/foregrounds/foregrounds0.json"),
                    new TextureAsset("foregrounds1", "sheets/foregrounds/foregrounds1.json"),
                    new TextureAsset("foregrounds2", "sheets/foregrounds/foregrounds2.json")
                ],
                animations : {}
            }
        ]
    };
}